/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd"><circle pid="0" cx="10" cy="6" r="5"/><path pid="1" d="M1 15l5-5" stroke-linecap="round"/></g>'
  }
})
